import { gql } from "graphql-request";

export const CREATE_PENDING_PUNCH = gql`
  mutation CreatePendingPunch(
    $dayId: ID!
    $punchId: ID!
    $in: Time
    $out: Time
    $oldIn: Time
    $oldOut: Time
    $penalty: Int
  ) {
    createPendingPunch(
      data: {
        day: $dayId
        punch: $punchId
        in: $in
        out: $out
        oldIn: $oldIn
        oldOut: $oldOut
        penalty: $penalty
      }
    ) {
      documentId
      in
      out
      oldIn
      oldOut
      approved
      punch {
        documentId
      }
      penalty
    }
  }
`;

export const UPDATE_PENDING_PUNCH = gql`
  mutation UpdatePendingPunch($punchId: ID!, $userId: ID!, $approved: Boolean) {
    updatePendingPunch(
      documentId: $punchId
      data: { approved: $approved, approvedBy: $userId }
    ) {
      documentId
      in
      out
      approved
      punch {
        documentId
        in
        out
        location
      }
      penalty
    }
  }
`;

export const UPDATE_PENDING_PUNCH_TIME = gql`
  mutation UpdatePendingPunchTime(
    $punchId: ID!
    $in: Time
    $out: Time
    $penalty: Int
  ) {
    updatePendingPunch(
      documentId: $punchId
      data: { in: $in, out: $out, penalty: $penalty }
    ) {
      documentId
      in
      out
      approved
      punch {
        documentId
      }
      penalty
    }
  }
`;

export const DELETE_PENDING_PUNCH = gql`
  mutation DeletePendingPunch($punchId: ID!) {
    deletePendingPunch(documentId: $punchId) {
      documentId
    }
  }
`;
